import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { displayUI } from "../../storage/emitter";
import { motion } from "framer-motion";
import cx from "classnames";
import style from "./TopBar.module.scss";
import { fade } from "../../storage/motionAnimations";
import { format } from "date-fns";

const Timer = () => {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timerUpdate = setInterval(() => {
      setDate(new Date());
    }, 500);
    return () => {
      clearInterval(timerUpdate);
    };
  }, []);

  return <div className="timer">{format(date, "HH:mm")}</div>;
};

export default function TopBar() {
  const { pathname } = useLocation();

  useEffect(() => {
    // make sure the UI is displayed on every path-change
    displayUI();
  }, [pathname]);

  return (
    <motion.header
      className={cx("bar", "top-bar", style.bar)}
      variants={fade}
      initial="visible"
      animate="visible"
      exit="exit"
    >
      <div className="bar-wrapper">
        <div className="icon casting" />
        <div className="icon volume_high" />
        <div className="icon bluetooth" />
      </div>
      <div className="bar-wrapper">
        <div className="weather-info">
          <span className="icon weather" />{" "}
          <span className="temperature">5ºC</span>
        </div>
        <Timer />
      </div>
    </motion.header>
  );
}
